import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    // flexDirection: 'column',
    backgroundColor: 'white',
    height: '100%'
  },
  section: {
    margin: "10px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  detailsSection: {
    display: "flex",
    flexDirection: 'column',
    gap: "25px 0px",
    marginTop: "20px"


  },
  container: {
    display: "flex",
    flexDirection: "row",
    // alignItems: 'flex-start'
    alignItems: 'center',
    justifyContent: 'center'

  },

});
const reportStyles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

  },
  text: {
    textAlign: "center",
    wordWrap: "break-word",
    maxWidth: "100%",
    fontSize: "12px",
  }
});




// Create Document Component
const DocumentFormat = ({ data }) => (
  <Document>

    <Page size="A4" style={styles.page}>
      {/* Image */}
      <View style={styles.section}>
        <Text style={{ marginTop: 20, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>TECH STACK: {data.techstack}</Text>
        {/* <View className={reportStyles.container}>
          <Text className={reportStyles.text}>{data.techstack}</Text>
        </View> */}
        <Text style={{ marginTop: 20, color: '#000000', fontSize: 12 }}>JOB TITLE: {data.jobTitle}</Text>
        {/* <Text className={reportStyles.titleText}>{data.jobTitle}</Text> */}
        {/* <View className={reportStyles.container}>
        </View> */}
        <Text style={{ marginTop: 20, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>JOB DESCRIPTION:</Text>
        <Text style={{ marginTop: 7, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>{data.jobDescription}</Text>
        {/* <View className={reportStyles.container}>
          <Text className={reportStyles.text}>{data.jobDescription}</Text>
        </View> */}
        <Text style={{ marginTop: 20, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>PROPOSAL:</Text>
        <View className={reportStyles.container}>
          <Text style={{ fontSize: 12 }}>{data.proposal}</Text>
        </View>
      </View>
     
    </Page>

    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={{ marginTop: 20, color: '#000000', fontWeight: 'bold', fontSize: 12 }}>QUESTION & ANSWERS:</Text>
        {data.answers.map((item, index) => {
          return <>
            <View className={reportStyles.container}>
              <Text style={{ marginTop: 10, fontSize: 12 }} className={reportStyles.text}>{index + 1}.Question:-</Text>
              <Text style={{ fontSize: 12 }}>{item.question}</Text>
            </View>
            <View className={reportStyles.container}>
              <Text style={{ fontSize: 12 }}>{item.answer}</Text>
            </View>
          </>
        })}

      </View>
    </Page>
  </Document>
);

export default DocumentFormat;
